// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-text-input-container {
  /* margin: 3px; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.form-text-input-label {
  font-size: 0.8em;
  font-weight: bolder;
}

.form-text-input-container input {
  width: 100%;
  border: none;
  margin-top: 2px;
  height: 25px;
  border-radius: 5px;
  padding-inline: 0px;
  padding-block: 0px;
}

.form-text-input-label-container {
  flex: 1 1;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/Components/FormInput/FormTextInput.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC","sourcesContent":[".form-text-input-container {\n  /* margin: 3px; */\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  width: 100%;\n}\n\n.form-text-input-label {\n  font-size: 0.8em;\n  font-weight: bolder;\n}\n\n.form-text-input-container input {\n  width: 100%;\n  border: none;\n  margin-top: 2px;\n  height: 25px;\n  border-radius: 5px;\n  padding-inline: 0px;\n  padding-block: 0px;\n}\n\n.form-text-input-label-container {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
